import { render } from "./TheMain.vue?vue&type=template&id=26f82eb2"
import script from "./TheMain.vue?vue&type=script&lang=js"
export * from "./TheMain.vue?vue&type=script&lang=js"
script.render = render

export default script